import React from 'react';
import { createRoot } from 'react-dom/client';
import '../src/css/Item.css'
import '../src/css/bootstrap.min.css'
import '../src/css/style.css'
import '../src/css/style_s.css'
import '../src/css/responsive.css'
// import '../src/css/index.css'
// import 'bootstrap/dist/js/bootstrap.min.js'
// import 'jquery/dist/jquery.min.js'
import App from './App';
import Store  from './Store/Store';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Store>
    <App />
  </Store>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

